module.exports = __webpack_public_path__ + "img/21.948b487a.jpg";